module.exports = __webpack_public_path__ + "img/avatar.ddd52541.svg";